import { createStyles, Theme } from '@material-ui/core'

export const conceptQuantityCardStyles = (theme: Theme) =>
  createStyles({
    formWithOutToolbar: {
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      }
    },
    title: {
      '& .MuiTypography-h6': {
        fontSize: '1.2rem',
        fontWeight: 400,
        lineHeight: 1.334,
        letterSpacing: '0em'
      }
    },
    card: {
      // Targetear elementos internos del Form de globaleris.ui
      '& .MuiToolbar-root': {
        marginTop: '0px !important',
        marginBottom: '0px !important',
        paddingTop: '8px !important',
        minHeight: '0px !important'
      },
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: '0px !important',
        marginTop: '0px !important',
        marginBottom: '0px !important'
      },
      '& .makeStyles-mainSectionHeader': {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        border: '1px red !important'
      },
      '& [class*="makeStyles-mainSectionHeader"]': {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        border: '1px red !important'
      },
      '& .makeStyles-mainSectionTitle': {
        marginTop: '16px !important',
        padding: '0 !important',
        border: '1px red !important'
      },
      '& [class*="makeStyles-mainSectionTitle"]': {
        marginTop: '16px !important',
        padding: '0 !important',
        border: '1px red !important'
      },
      '& .MuiCardContent-root': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(1)
      },
      '& .MuiGrid-container': {
        marginTop: '0 !important',
        marginBottom: '0 !important',
        paddingLeft: '32px !important',
        paddingRight: '32px !important'
      },
      '& .MuiGrid-item': {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
      },
      '& .MuiFormControl-root': {
        marginTop: '0 !important',
        marginBottom: '0 !important'
      }
    }
  })
